import BuildingDetailsListItem from './BuildingDetailsListItem.component';

export default BuildingDetailsListItem;
